export const ROUTE_UNSUBSCRIBE_EMAIL = 'unsubscribe-email';
export const ROUTE_SUCCESSFUL_UNSUBSCRIBE_EMAIL = 'successful-unsubscribe-email';
export const ROUTE_FAILED_UNSUBSCRIBE_EMAIL = 'failed-unsubscribe-email';